import { render, staticRenderFns } from "./DatatableWorkshopsWhatsApp.vue?vue&type=template&id=9f4df784"
import script from "./DatatableWorkshopsWhatsApp.vue?vue&type=script&lang=js"
export * from "./DatatableWorkshopsWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./DatatableWorkshopsWhatsApp.vue?vue&type=style&index=0&id=9f4df784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports